import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { searchTerm } from '@/lib/search'
import { useDebounced } from './use-debounced'

/** Text z vyhľadávacieho poľa pripravený na dotaz: oneskorený o `delayMs` a prázdny, kým je krátky (lib/search.ts). */
export function useSearchTerm(value: string, delayMs = 300): string {
  return searchTerm(useDebounced(value, delayMs))
}

/**
 * Vyhľadávanie zoznamu v URL parametri `search`: pole sa mení hneď, URL až po
 * `delayMs` a len s dosť dlhým textom — kratší text filter zruší. Zmena vráti
 * zoznam na 1. stranu. `term` = aplikovaný text pre dotaz na API, `apply()`
 * ho nastaví hneď (Enter).
 */
export function useUrlSearch(delayMs = 250) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [search, setSearch] = useState(searchParams.get('search') ?? '')
  const applied = searchParams.get('search') ?? ''

  function apply(value = search) {
    const next = searchTerm(value)
    setSearchParams((prev) => {
      const p = new URLSearchParams(prev)
      if (next) p.set('search', next)
      else p.delete('search')
      p.delete('page')
      return p
    }, { replace: true })
  }

  // Len na zmenu poľa — externá zmena URL (odkaz na ?search=…) sa nesmie prepísať starým textom.
  useEffect(() => {
    if (searchTerm(search) === applied) return
    const t = setTimeout(() => apply(search), delayMs)
    return () => clearTimeout(t)
  }, [search]) // eslint-disable-line react-hooks/exhaustive-deps

  return { search, setSearch, term: searchTerm(applied), apply }
}
